import { AbstractBrickSettingRemoteDto } from '../../../../../generated/signalR/abstract-brick-setting-remote-dto';
import { IBrickInstanceTargetingAction } from '../../../utility/IBrickInstanceTargetingAction';

export class BrickSettingsChangedByServer {
   public static readonly type = '[BrickSettings] Brick settings changed by server';

   constructor(public brickSettings: { [p: string]: AbstractBrickSettingRemoteDto }) {}
}

export class OpenBrickSettingsDialog implements IBrickInstanceTargetingAction {
   public static readonly type = '[Brick Settings] Open brick settings dialog';

   constructor(public brickInstanceId: string) {}
}

export class CloseBrickSettingsDialog {
   public static readonly type = '[Brick Settings] Close brick settings dialog';

   constructor(public openParentSettings: boolean) {}
}
